"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.keyArrowUp = exports.keyArrowRight = exports.keyArrowLeft = exports.keyArrowDown = exports.keyTab = exports.keyShift = exports.keyAlt = exports.keyEnter = void 0;
exports.keyEnter = 'Enter';
exports.keyAlt = 'Alt';
exports.keyShift = 'Shift';
exports.keyTab = 'Tab';
exports.keyArrowDown = 'ArrowDown';
exports.keyArrowLeft = 'ArrowLeft';
exports.keyArrowRight = 'ArrowRight';
exports.keyArrowUp = 'ArrowUp';
//# sourceMappingURL=event-keys.js.map